module.exports = __webpack_public_path__ + "img/5.8ff419d2.png";